<a class="link" tabindex="0" [attr.data-testid]="testId()">
  <mat-icon [svgIcon]="IconNames.ice_arrow_left" />
  <span class="link-text">Tilbake</span>
</a>
